export const locale = {
  lang: 'en',
  data: {
    annualDeclaration: {
      fillForm: "Fill form",
      downloadSummary: "Download summary",
      registerReport: 'Generate full company report',
      registerReportTitle: 'Company Registry Form'
    },
    company: {
      formState: {
        status: {
          Payed: 'Payed'
        }
      }
    }
  }
};
